export class MapCondition {
  public formatTypeID: number
  public datasetID: number;
  public conditionText: string;
  public dataCriteriaCondition: string;
  public ids: string[] = []
}
